import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { ClientHistory } from './clientHistory';


@JsonObject('ClientHistorySearchResults')
export class ClientHistorySearchResults extends SearchResults {
    @JsonProperty('results', [ClientHistory])
    results: ClientHistory[] = [];
}
